<div [ngStyle]="{ height: dialogHeight, width: dialogWidth }" class="searchable-list-dialog-container">
  <emperor-card-header class="card-header" [color]="colorPrimary">
    {{ headerText }}
    <emperor-icon class="close-icon" name="close_1" (click)="close()"></emperor-icon>
  </emperor-card-header>
  <emperor-searchable-list class="searchable-list" [question]="searchableListQuestion" [questionControl]="searchableListQuestionControl">
  </emperor-searchable-list>
  <emperor-card-footer class="card-footer">
    <emperor-button [uiButtonType]="textButton" (click)="close()"> CANCEL </emperor-button>

    <emperor-button (click)="save()">SAVE & CLOSE</emperor-button>
  </emperor-card-footer>
</div>
